import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { TellentDevFlagsHttpClient } from './tellent-dev-flags.http';
import { TellentDevFlagsActions } from './tellent-dev-flags.store';

@Injectable({
  providedIn: 'root',
})
export class TellentDevFlagsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(TellentDevFlagsHttpClient);

  private effects = createEffectFactory(TellentDevFlagsActions, this.actions$);

  private fetch$ = this.effects(TellentDevFlagsActions.fetch, () => this.http.fetch());
}
